import DualListView from "../components/DualListView"
import AdAnnotations from '../react/annotations/AdAnnotations'
import ResolvedAnnotationsHandler from '../components/ResolvedAnnotationsHandler'
import AssetUploader from '../components/uploads/AssetUploader'
import N2StylesModal from '../components/N2StylesModal'

export default class AdDesignJobsWizard {
  constructor(params) {
    this.params = params;
    this.assetUploader = new AssetUploader(this, { dropContainer: '.js-supply-file-drop'});
  }

  unload() {
    AdAnnotations.unload()
    this.assetUploader.unload()
  }

  show() {
    switch (this.params.id) {
      case 'choose_ad_type':
        this.bindNoReusuableJobCard()
        break;
      case 'work_on_ad':
        if (this.params.jobSource == 'reuse') {
          this.bindRedesignButton();
          this.bindRerunButton();
          new DualListView({roleType: this.params.role})
        } else if (this.params.jobSource == 'design' && this.locationForAnnotations()) {
          this.setupAnnotations();
        } else if (this.params.jobSource == 'supply') {
          this.assetUploader.init();
        }
        break;

      case 'finish_ad':
        this.bindSafeAreaToggle();
        this.addSafeAreaBorder();
        break;
    }
    this.bindLastStepModal()
  }

  locationForAnnotations() {
    return window.location.search.includes("view=proof") ||
      window.location.search == "" || window.location.search.includes("issue=")
  }

  assetUploadUrl() {
    return `/ad_design_jobs/${this.params.adDesignJobId}/assets`;
  }

  assetUploadImageLabel() {
    return this.params.type == "Annotation::AddPhoto" ? "Photos" : "Files"
  }

  addSafeAreaBorder() {
    const { safeTop, safeRight, safeBottom, safeLeft } = this.params;

    if (safeTop || safeRight || safeBottom || safeLeft) {
      // For 2-page ads, the spine is included in the safe area
      if (this.params.adSizeValue === 2) {
        this._addSafeAreaSpineCSS("border-right", safeLeft + safeRight, "-50%");
      }

      this._addSafeAreaCSS("border-top", safeTop);
      this._addSafeAreaCSS("border-right", safeRight);
      this._addSafeAreaCSS("border-bottom", safeBottom);
      this._addSafeAreaCSS("border-left", safeLeft);
    }
  }

  setupAnnotations() {
    // unload here in event user pushed back in browser
    AdAnnotations.unload()
    if ($('img.js-annotation-boundry').length) {
      let img = new Image()
      img.src = $('img.js-annotation-boundry')[0].src
      img.onload = () => {
        this.adAnnotations = AdAnnotations.init();
        this.setupResolvedHandler()
      }
    } else {
      this.adAnnotations = AdAnnotations.init();
      this.setupResolvedHandler()
    }
  }

  setupResolvedHandler() {
    let currAnno = $.grep(this.adAnnotations.annotations, (anno) => { return anno.id == this.params.currentAnnotation; })[0] || {};
    // has to come after annotations init
    new ResolvedAnnotationsHandler({resolved: currAnno.resolved})
  }

  bindSafeAreaToggle() {
    if (!$(".js-show-safe-area").length) { return false }

    N2.handle("click", ".js-show-safe-area", (e) => {
      let checked
      if ($(".js-safe-area-input").prop('checked')) {
        checked = false
        $('.safe-area').addClass('inactive')
      } else {
        checked = "checked"
        $('.safe-area').removeClass('inactive')
      }
      $(".js-safe-area-input").prop("checked", checked);
    });
  }

  bindRerunButton() {
    N2.handle('click', '.js-not-rerunable', (e) => {
      new N2Styles.toast('This job is not available to be reused because it is a different size &/or color.')
    })
  }

  bindRedesignButton() {
    N2.handle('click', '.js-not-redesignable', (e) => {
      new N2Styles.toast('This job is not available to be redesigned because it was supplied.')
    })
  }

  bindNoReusuableJobCard() {
    N2.handle('click', '.js-no-reusable-job', (e) => {
      new N2Styles.toast('No past jobs available to reuse this month. Please choose to supply or design this ad.')
    })
  }

  bindLastStepModal() {
    N2.handle('click', '.js-no-last-step-available', (e) => {
      let url = $(e.currentTarget).data("url");
      let modal = $(e.currentTarget).data("modal");
      let finishPath = $(e.currentTarget).data("finishPath");
      $.get(url, { format: "json" }, (data) => {
        if (data.valid) {
          window.location = finishPath
        } else {
          $('.js-error-message').text(data.message);
          new N2StylesModal(modal)
        }
      });
    })
  }

  _addSafeAreaCSS(cssRuleName, pxSize) {
    const borderDeclaration = `${cssRuleName}: ${pxSize}px solid ${this._safeAreaColor()}`;
    const cssRule = `.safe-area:after { ${borderDeclaration} }`;
    N2.addCSSRule(cssRule);
  }

  _addSafeAreaSpineCSS(cssRuleName, pxSize, translateX) {
    const borderDeclaration = `${cssRuleName}: ${pxSize}px solid ${this._safeAreaColor()};`;
    const transformDeclaration = `transform: translateX(${translateX});`;
    const cssRule = `.safe-area:before { ${borderDeclaration} ${transformDeclaration}}`;
    N2.addCSSRule(cssRule);
  }

  _safeAreaColor() {
    return "rgba(240, 58, 118, 0.8)";
  }
}
